import * as React from 'react';
import { observer } from 'mobx-react';
import { INormalizedCheckboxTextProps } from './INormalizedCheckboxTextProps';
import { Parameter } from 'MeasurementsCalculations';
import { ReportKind } from 'Data';

@observer
export class NormalizedCheckboxText extends React.Component<
  INormalizedCheckboxTextProps,
  undefined
> {
  constructor(props: INormalizedCheckboxTextProps) {
    super(props, undefined);
  }

  getValueInChosenUnit(value: number, propertyName: string) {
    if (propertyName) {
      return this.props.unitPresentation.toString(Parameter[propertyName], value);
    } else {
      return null;
    }
  }

  getParameterUnit(propertyName: string) {
    return this.props.unitPresentation.displayUnit(Parameter[propertyName]);
  }

  render() {
    if (!this.props.showNormalizedData && this.props.reportKind === ReportKind.testCenterReport) {
      return <span>The distances have not been normalized.</span>;
    }

    const showNormalizedDetails =
      this.props.normalizedEnvironmentDetails?.altitude !== null &&
      this.props.normalizedEnvironmentDetails?.temperature !== null;
    const seaLevelAltitude = <span>sea level altitude</span>;
    const belowSeaLevel = <span>below sea level altitude</span>;
    const aboveSeaLevel = <span>above sea level altitude</span>;
    return (
      <span>
        <span>All distances have been normalized</span>
        {showNormalizedDetails ? (
          <span>
            <span> to </span>
            <span>
              {this.getValueInChosenUnit(
                this.props.normalizedEnvironmentDetails.temperature,
                'Temperature'
              )}
            </span>
            <span>{this.getParameterUnit('Temperature')}</span>
            <span>, and </span>
            {this.props.normalizedEnvironmentDetails.altitude === 0
              ? seaLevelAltitude
              : this.props.normalizedEnvironmentDetails.altitude > 0
              ? aboveSeaLevel
              : belowSeaLevel}
          </span>
        ) : (
          ''
        )}
        <span>.</span>
      </span>
    );
  }
}
